import Vue from 'vue'
import confirm from './index.vue'
const constructor = Vue.extend(confirm)
const customConfirm = function(text) {
  return new Promise((resolve, reject) => {
    const DOM = new constructor({ el: document.createElement('div') })
    document.body.appendChild(DOM.$el) // new一个对象，然后插入body里面
    DOM.text = text // 为了使confirm的扩展性更强，这个采用对象的方式传入，所有的字段都可以根据需求自定义
    DOM.handleOk = function() {
      DOM.submitLoading = true // 打开确定按钮loading状态
      resolve()
      DOM.isShow = false
    }
    DOM.handleClose = function() {
      reject()
      DOM.isShow = false
    }
  })
}
export default customConfirm